import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import config from '../../config';
import { ERROR_MESSAGES } from '../../consts';
import { IAppState } from '../../types/state.d';
import { getSelectedCharityId } from '../../selectors/apiSelectors';
import {
  getCharityDataRequestMade,
  getCharityDataRequestSuccess,
  getCharityDataRequestError,
} from '../actionCreators/apiActions';

const fetchCharityData = () => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
) => {
  try {
    dispatch(getCharityDataRequestMade());
    const chariyId = getSelectedCharityId(getState());
    const response = await makeRequest(`${config.charityAPI}${chariyId}`, {
      credentials: 'omit',
    });

    if (response && !response.ok) {
      throw new Error(ERROR_MESSAGES.GET_EVENT_DETAILS);
    }

    const data = await response.json();
    dispatch(getCharityDataRequestSuccess({ countryCode: data.countryCode }));
  } catch (error) {
    dispatch(getCharityDataRequestError(error.message));
  }
};

export default fetchCharityData;
